import React, { useState } from "react";
import { connect } from "react-redux";
import ForwardModalItem from "./ForwardModalItem";

const ForwardModal = props => {
  const [forwardContactList, setForwardContactList] = useState([]);
  // const [contactsid, setContactsid] = useState([]);

  const activeSendToTab = target => {
    let targets = [
      ...document.querySelectorAll(".modal__content__encaminhar__group")
    ];
    targets.forEach(t => t.classList.remove("active"));

    let modalTargets = [
      ...document.querySelectorAll(".modal__content__encaminhar")
    ];
    modalTargets.forEach = mt => mt.classList.remove("active");

    if (target === "to-one") {
      document
        .querySelector(".modal__content__encaminhar__group--out")
        .classList.add("active");
      document.querySelector(".to-one").classList.add("active");
    } else {
      document
        .querySelector(".modal__content__encaminhar__group--in")
        .classList.add("active");

      document.querySelector(".to-group").classList.add("active");
    }

    let targetClass = `.${target}`;
    document.querySelector(targetClass).classList.add("active");
  };

  const handleTabClick = (event, target) => {
    event.preventDefault();
    if (event.target.classList.contains("active")) return null;

    let tabs = [...document.querySelectorAll(".form-container-btn__form-btn")];
    tabs.map(tab => {
      if (tab.classList.contains("active")) {
        tab.classList.remove("active");
      } else {
        tab.classList.add("active");
      }
      return null;
    });
    activeSendToTab(target);
  };

  const handleSearch = ({ target }) => {
    console.log(target.value);
  };

  const handleCheck = atd => {
    const isAdded = forwardContactList.filter(
      item => item.cliente === atd.cliente
    );
    if (isAdded.length > 0) {
      const newForwardContactList = forwardContactList.filter(
        item => item.cliente !== atd.cliente
      );
      setForwardContactList(newForwardContactList);
    } else {
      setForwardContactList([...forwardContactList, atd]);
    }
  };

  // useEffect(() => {
  //   // let contactList = [];
  //   // forwardContactList.forEach(contact => {
  //   //   contactList.push(contact.serviceatd);
  //   // });
  //   // setContactsid(contactList);
  //   props.updateForwardContactList(forwardContactList);
  // }, [forwardContactList]);

  return (
    <div
      className="modal micromodal-slide"
      id="modal__encaminhar"
      aria-hidden="true"
      role="dialog"
    >
      <div className="modal__overlay" tabIndex="-1">
        <div
          className="modal__container"
          role="dialog"
          aria-modal="true"
          aria-labelledby="modal__encaminhar__title"
        >
          <header className="modal__header">
            <h2 className="modal__title" id="modal__encaminhar__title">
              Encaminhar para
            </h2>

            <button
              className="modal__close"
              aria-label="Close modal"
              data-micromodal-close
              onClick={e => {
                e.preventDefault();
                setForwardContactList([]);
                props.handleCloseEncaminhar();
              }}
            ></button>
          </header>
          <div className="modal__header__bottom-line"></div>
          <main
            className="modal__content modal__content--small"
            id="modal__encaminhar__content"
          >
            <div className="modal__content__user-details__content">
              <form action="" className="modal__content__form">
                <div className="modal__content__form__group modal__content__form__group--col-8">
                  <div className="modal__content">
                    <div className="full-search">
                      <input
                        type="text"
                        name="client-search"
                        id="client-search"
                        placeholder="Busca..."
                        onChange={event => handleSearch(event)}
                      />
                      <button type="submit" className="full-search__btn">
                        <i className="material-icons">search</i>
                      </button>
                    </div>

                    <div className="form-container-btn">
                      <button
                        className="form-container-btn__form-btn a active"
                        onClick={event => handleTabClick(event, "to-one")}
                      >
                        Interações em curso
                      </button>
                      <button
                        className="form-container-btn__form-btn b"
                        onClick={event => {
                          event.preventDefault();
                          // handleTabClick(event, "to-group");
                        }}
                      >
                        Grupos
                      </button>
                    </div>
                  </div>

                  {/* <div className="modal__content__form__group modal__content__form__group--col-8"></div> */}
                  <div className="flows">
                    <div className="modal__content__encaminhar__group modal__content__encaminhar__group--out active">
                      <div className="modal__content__encaminhar to-one active">
                        {/* INDIVIDUAL */}
                        {props.AtdSimult.map(atd => (
                          <ForwardModalItem
                            key={atd.servico}
                            {...atd}
                            handleCheck={() => handleCheck(atd)}
                            isChecked={
                              forwardContactList.filter(
                                f => f.cliente === atd.cliente
                              ).length > 0
                                ? true
                                : false
                            }
                            type="single"
                          />
                        ))}
                      </div>
                    </div>
                    <div className="modal__content__encaminhar__group modal__content__encaminhar__group--in">
                      <div className="modal__content__encaminhar to-group">
                        {/* GROUP */}
                        {/* {props.AtdSimult.map(atd =>
                          (
                            <ForwardModalItem
                              key={atd.servico}
                              {...atd}
                              handleCheck={() => handleCheck(atd)}
                              isChecked={
                                forwardContactList.filter(
                                  cliente => cliente === atd.cliente
                                ).length > 0
                                  ? true
                                  : false
                              }
                              type="group"
                            />
                          )
                        )} */}
                      </div>
                    </div>
                  </div>

                  <div className="encaminhar-footer">
                    <div className="modal__content__form__group modal__content__form__group--col-4">
                      <a
                        className="modal__content__form__group__button modal__content__form__group__button--white"
                        data-micromodal-close
                        onClick={e => {
                          e.preventDefault();

                          setForwardContactList([]);
                          props.handleCloseEncaminhar();
                        }}
                      >
                        Cancelar
                      </a>
                    </div>
                    <div className="modal__content__form__group modal__content__form__group--col-4">
                      <a
                        className="modal__content__form__group__button "
                        // onClick="toggleModal('modal__desbloqueio')"
                        onClick={e => {
                          e.preventDefault();
                          // props.handleForwardConfirm(contactsid);
                          props.handleForwardConfirm(forwardContactList);
                          setForwardContactList([]);
                        }}
                      >
                        OK
                      </a>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </main>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = state => ({
  AtdSimult: state.atdsimult
});

export default connect(mapStateToProps)(ForwardModal);
